import styled from 'styled-components';
import { th } from 'style/theme';

export const StyledSubscriptionCard = styled.div`
  border-radius: 16px;
  background-color: ${th('colors.fountainBlue+3')};
  padding: 8px 16px;
  margin-top: 16px;
  font-size: 16px;
  color: ${th('colors.black')};

  > button {
    background: none;
    border: none;
    padding: 0;
    font-size: inherit;
    font-family: inherit;
    font-weight: 500;
    color: ${th('colors.black')};
    text-decoration: underline;
    cursor: pointer;

    :hover {
      color: ${th('colors.fountainBlue-4')};
    }
  }
`;
